// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"0":"draw","177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"0":"67de2c37","177":"323ac270","328":"4f7c96f7","382":"f00ce3e8","571":"15f69a78","821":"4adb24ad"}[chunkId] + ".css";
};